module.exports = __webpack_public_path__ + "static/media/banner-3.c46d9966.jpeg";